<template>
  <div class="package-weigh">
    <div class="package-weigh-container">
      <div class="title">包裹称重</div>
      <div class="form">
        <!-- <img class="form-img" src="../assets/images/signin.png" alt /> -->
        <!-- <van-search v-model="search" placeholder="搜索想要的波次号" @blur="onSearch" /> -->
        <div class="search-criteria">
          <div class="search-title">搜索条件</div>
          <van-field
            class="search-time"
            :label="search.label"
            :value="search.time"
            @click="searchTime"
            right-icon="arrow"
          />
          <van-popup
            v-model="show"
            position="bottom"
            :style="{ height: '30%' }"
          >
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择年月日"
              @confirm="onConfirmManufactureDate"
              @cancel="cancelFn()"
              :minDate="minDate"
            />
          </van-popup>
          <van-field
            class="search-waveNum"
            v-model="search.waveNum"
            placeholder="请输入波次号"
            right-icon="scan"
          />
          <van-button
            v-if="isSearchBtn"
            class="btn"
            type="info"
            block
            @click="onSearch"
            >开始搜索</van-button
          >
          <van-button
            v-else-if="!isSearchBtn&&isError"
            class="btn-clear"
            type="info"
            block
            @click="clear"
            >清空</van-button
          >
          <van-button
            v-else-if="!isSearchBtn&&!isError"
            class="btn"
            type="info"
            block
            @click="clear"
            >清空</van-button
          >
        </div>
      </div>
      <div class="search-result" v-if="!isSearchBtn&&isError">
        <div class="main" v-if="!isSearchBtn&&isError">
          <van-field label="订单数" v-model="orderNum" />
          <van-field class="weigh" label="重量" v-model="weigh" />
          <van-button :disabled="isDisabled" :class="!isDisabled?'confirm':'grey'" type="info" block @click="confirm">确认</van-button>
        </div>
        <div v-if="!isSearchBtn&&!isError" class="nothing">
          <img src="../assets/images/nothing.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Field,
  Button,
  Search,
  Toast,
  Dialog,
  DatetimePicker,
  Popup,
} from "vant";
Vue.use(Field)
  .use(Button)
  .use(Search)
  .use(Toast)
  .use(Dialog)
  .use(Popup)
  .use(DatetimePicker);
export default {
  data() {
    return {
      search: {
        time: "",
        waveNum: "",
        label: "",
      },
      isSearchBtn: true,
      isError: true,
      show: false,
      minDate: new Date(2020, 0, 1),
      currentDate: new Date(),
      orderNum: "",
      weigh: "",
      isDisabled: true,
    };
  },
  watch: {
    orderNum(oldVal, newVal) {
      if (this.orderNum && this.weigh) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    weigh(oldVal, newVal) {
      if (this.orderNum && this.weigh) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },

  created() {
    this.initDate();
  },

  methods: {
    initDate() {
      let date = new Date();
      this.search.label = `${date.getFullYear()}年`;
      this.search.time = `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    onSearch() {
      this.isSearchBtn = false;
      this.isError = true;
    },
    clear() {
      this.search.waveNum = ''
    },
    searchTime() {
      this.show = true;
    },
    /* 点击输入框确认选择时间 */
    onConfirmManufactureDate(date) {
      if (date == "" || date == null) {
        return;
      } else {
        date = new Date(date);
        this.search.label = `${date.getFullYear()}年`;
        this.search.time = `${date.getMonth() + 1}月${date.getDate()}日`;
      }
      this.show = false;
    },
    cancelFn() {
      this.show = false;
    },
    confirm() {
      Dialog.confirm({
        title: "提示",
        message: "确认后重量不可修改",
        className: "confirm-dialog",
        cancelButtonColor: "#333",
        confirmButtonColor: "#fff",
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang='less' scoped>
.package-weigh {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .package-weigh-container {
    flex: 1;
    background: url(../assets/images/package-weigh.png) center top no-repeat;
    background-size: 420px;
    padding: 0px 12px 30px 12px;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      margin-top: 14px;
    }
    .search-criteria {
      .search-title {
        position: relative;
        height: 44px;
        line-height: 44px;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: " ";
          width: 100%;
          pointer-events: none;
          bottom: 0px;
          left: 0px;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
      }
    }
    .form {
      margin-top: 69px;
      padding: 0px 20px 20px 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 10px 0px rgba(0, 104, 255, 0.1);
      border-radius: 8px;
      position: relative;
      .form-img {
        position: absolute;
        left: 50%;
        top: -35px;
        width: 106px;
        height: 54px;
        margin-left: -53px;
      }
      // .van-search {
      //   height: 36px;
      //   background: #F5F6F7;
      //   border-radius: 4px;
      //   padding: 0px;
      //   margin-bottom: 50px;
      //   .van-search__content {
      //     height: 36px;
      //     .van-cell {
      //       margin-bottom: 0px;
      //     }
      //   }
      // }
      // .main {
      //   /deep/ .van-field {
      //     padding: 0;
      //     display: flex;
      //     align-items: center;
      //     margin-bottom: 15px;
      //     .van-field__label {
      //       max-width: 60px;
      //       min-width: 60px;
      //       font-weight: bold;
      //       color: rgba(51, 51, 51, 1);
      //       font-size: 15px;
      //       margin-right: 0px;
      //     }
      //     .van-field__body {
      //       height: 36px;
      //       border: 1px solid rgba(189, 203, 230, 1);
      //       border-radius: 2px;
      //       padding-left: 10px;
      //       padding-right: 10px;
      //     }
      //   }
      //   .van-cell::after {
      //     border-bottom: 0;
      //   }
      .confirm {
        width: 100%;
        height: 44px;
        background: rgba(0, 104, 255, 1);
        box-shadow: 0px 3px 9px 0px rgba(0, 104, 255, 0.36);
        border-radius: 4px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
      }
      // }
    }
    .search-result {
      margin-top: 12px;
      padding: 0px 20px 20px 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 10px 0px rgba(0, 104, 255, 0.1);
      border-radius: 8px;
    }
    .btn {
      height: 44px;
      background: #0068FF;
      border-radius: 22px;
      font-size: 18px;
      font-weight: 400;
    }
    .btn-clear {
      height: 44px;
      background: #ffffff;
      border-radius: 22px;
      border: 0.5px solid #0068FF;
      font-size: 18px;
      font-weight: 400;
      color: #0068FF;
    }
  }
  .nothing {
    display: flex;
    justify-content: center;
    img {
      width: 156px;
      height: 90px;
    }
  }
}
</style>
<style lang="less">
.package-weigh {
  .search-time {
    padding-left: 0px;
    padding-right: 0px;
    .van-field__label {
      width: 40px;
      margin-right: 0px;
      font-size: 12px;
      color: #666;
      font-weight: 400;
    }
    .van-field__control {
      font-size: 12px;
      color: #333;
      font-weight: 700;
    }
    .van-field__right-icon {
      color: #dcdcdc;
    }
    .van-field__right-icon .van-icon {
      font-size: 12px;
    }
    &::after {
      width: 100%;
      right: 0;
      left: 0;
    }
  }
  .search-waveNum {
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 20px;
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      width: 100%;
      pointer-events: none;
      bottom: 0px;
      left: 0px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .weigh {
    .van-field__label {
      span {
        letter-spacing: 15px;
      }
    }
  }
  .grey {
    border: none;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    background: #eeeeee;
  }
  .weigh {
    .van-field__body {
      &::after {
        content: "kg";
        width: 20px;
        height: 36px;
        line-height: 36px;
        font-size: 15px;
        font-weight: 400;
        color: #d3d8d0;
        position: absolute;
        right: 10px;
      }
    }
  }
}
</style>
<style>
.confirm-dialog {
  border-radius: 10px 10px;
}
.confirm-dialog .van-dialog__header {
  height: 44px;
  line-height: 44px;
  padding-top: 0px;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px solid #eee;
}
.confirm-dialog .van-dialog__message--has-title {
  font-size: 18px;
  font-weight: 400;
  color: #999999;
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding-top: 0px;
  padding-bottom: 0px;
}
.confirm-dialog .van-dialog__footer {
  height: 44px;
}
.confirm-dialog .van-dialog__cancel {
  background: #eee;
  border: none;
  height: 44px;
  border-radius: 0px 0px 0px 10px;
}
.confirm-dialog .van-dialog__confirm {
  background: #0068ff;
  border: none;
  height: 44px;
  border-radius: 0px 0px 10px 0px;
}
</style>
